(function () {
  'use strict';

  var STORAGE_KEY = 'comu:google-login-dismissed';

  function isDismissed(dismissDays) {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var dismissedAt = new Date(raw).getTime();
      if (isNaN(dismissedAt)) return false;
      var expiryMs = dismissDays * 24 * 60 * 60 * 1000;
      return (Date.now() - dismissedAt) < expiryMs;
    } catch (e) {
      return false;
    }
  }

  function dismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch (e) {}
  }

  function initPrompt(root) {
    if (!root || root.dataset.comuGlpReady === 'true') return;
    root.dataset.comuGlpReady = 'true';

    var delay = parseInt(root.getAttribute('data-delay') || '5', 10) * 1000;
    var dismissDays = parseInt(root.getAttribute('data-dismiss-days') || '7', 10);
    var autoHideEnabled = root.getAttribute('data-auto-hide-enabled') === 'true';
    var autoHideDelay = parseInt(root.getAttribute('data-auto-hide-delay') || '5', 10) * 1000;
    var autoHideTimer = null;

    function clearAutoHideTimer() {
      if (autoHideTimer) {
        clearTimeout(autoHideTimer);
        autoHideTimer = null;
      }
    }

    function autoHide() {
      if (root.hidden) return;
      root.classList.add('comu-glp--auto-hiding');

      function onEnd() {
        root.removeEventListener('animationend', onEnd);
        root.classList.remove('comu-glp--auto-hiding');
        root.hidden = true;
      }
      root.addEventListener('animationend', onEnd);

      setTimeout(function () {
        if (!root.hidden) {
          root.classList.remove('comu-glp--auto-hiding');
          root.hidden = true;
        }
      }, 400);
    }

    var closeBtn = root.querySelector('[data-comu-glp-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        clearAutoHideTimer();
        root.hidden = true;
        dismiss();
      });
    }

    var actionBtn = root.querySelector('[data-comu-glp-action]');
    if (actionBtn) {
      actionBtn.addEventListener('click', function () {
        clearAutoHideTimer();
        dismiss();
      });
    }

    if (!isDismissed(dismissDays)) {
      setTimeout(function () {
        root.hidden = false;
        bindScrollHide(root);

        if (autoHideEnabled && autoHideDelay > 0) {
          autoHideTimer = setTimeout(autoHide, autoHideDelay);
        }
      }, delay);
    }
  }

  function bindScrollHide(root) {
    var lastY = window.pageYOffset;
    var hidden = false;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking || hidden) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (window.innerWidth > 768 || root.hidden) return;
        var y = window.pageYOffset;
        if (y > lastY && y > 50) {
          root.classList.add('comu-glp--scroll-hidden');
          hidden = true;
        }
        lastY = y;
      });
    }, { passive: true });
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = container.querySelectorAll('[data-comu-google-login-prompt]');
    Array.prototype.forEach.call(roots, initPrompt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector('[data-comu-google-login-prompt]');
    if (root) {
      root.hidden = false;
    }
  });
})();
